const delivery = [
  { name: 'Address', path: 'address', meta: {} },
  { name: 'Housing', path: 'housing', meta: {} },
  { name: 'FurnitureTransport', path: 'access', meta: {} },
  { name: 'ParkingArea', path: 'parking', meta: {} },
];

const children = [
  ...delivery.map(elem => ({
    path: elem.path,
    component: elem.name,
    name: `delivery${elem.name}`,
    meta: elem.meta,
  })),
];


export default children;
